<template>
  <div>
    <!-- <ion-header> -->
    
    <div class="overlay mt-10">
      <ion-item lines="none">
        <ion-label>Season</ion-label>
        <ion-select placeholder="Select One" v-model="filterSeason">
          <ion-select-option v-for="season in seasons" :key="season._id" :value="season._id">{{ season._id }}</ion-select-option>
        </ion-select>
      </ion-item>
      <!-- <ion-item lines="none">
        <ion-select v-if="competitions.length > 0" placeholder="Select One" v-model="competitionId">
          <ion-select-option v-for="{_id, name} in competitions" :key="_id" :value="_id">{{ name }}</ion-select-option>
        </ion-select>
      </ion-item> -->
      <ion-toolbar>
        <!-- <ion-buttons slot="start" class="pl-20 pointer">
          <ion-icon :icon="caretDownOutline" @click="compListOpen = true"/>
        </ion-buttons> -->
        <ion-grid :scroll-x="true" class="competition-row ml-10" style="{'white-space': 'nowrap', 'padding-top': '1rem', background: $background !important}" nowrap>
          <ion-chip v-for="{_id, name} in competitions" :id="`competition-${_id}`" :key="_id" @click="changeCompetition(_id)" :class="{
            'mr-10': true,
            chip: true,
            active: competitionId === _id,
            selectable: competitionId !== _id
          }">
            <ion-label>{{ name }}</ion-label>
          </ion-chip>
        </ion-grid>
      </ion-toolbar>
    </div>
    <!-- </ion-header> -->
    <div class="" v-if="!compListOpen && !loading">
      <div class="flex flex-column justify-center" style="width:100%;">
        <ion-item class="mt-20 pl-10" lines="none">
          <ion-label>Stat</ion-label>
          <ion-select v-if="scoringTypes.length > 0 || nationalId == 9" v-model="eventType" interface="popover">
            <ion-select-option v-for="type in scoringTypes" :key="type.type" :value="type.type">{{`${type.name}s`}}</ion-select-option>
            <ion-select-option v-if="nationalId == 9" :key="-1" value="potm">Player of the Match</ion-select-option>
          </ion-select>
          <ion-text v-else color="white">
            No Scoring Events Found
          </ion-text>
        </ion-item>

        <ion-text v-if="eventLadder.competition"> <h4 class="round-text f-bold notranslate" > {{ eventLadder.competition.name }} </h4> </ion-text>
        <ScoringLadder v-if="eventType != 'potm'"  :key="key" :eventLadder="eventLadder" :eventType="find(scoringTypes, type => type.type === +eventType)" :loading="loading"/>
        <ScoringLadder v-if="eventType == 'potm' && nationalId == 9" :key="key" :eventLadder="eventLadder" :eventType="{name: 'POTM'}" :loading="loading"/>
        <div class="empty-container" v-if="!eventLadder">
          <ion-card>
            <ion-text color="secondary">
              <h1 class="empty-placeholder">No Leaderboard Available</h1>
            </ion-text>
          </ion-card>
        </div>
      </div>
    </div>

    <div v-else-if="!loading">
      <ion-text><h1 class="round-text text-center">COMPETITIONS</h1></ion-text>
      <ion-list>
        <ion-item v-for="{_id, name} in competitions" :key="_id" @click="competitionId = _id; compListOpen = false" >
          <ion-label>{{ name }}</ion-label>
          <!-- tick if selected -->
          <ion-checkbox slot="end" v-if="competitionId === _id" checked="true"></ion-checkbox>
        </ion-item>
      </ion-list>

    </div>

    <div v-else class="mt-10">
      <Skeleton />
    </div>

  </div>
</template>
  
<script>
import { ellipsisVertical, personCircle, flagOutline, podiumOutline,arrowBackOutline,arrowForwardOutline, caretDownOutline, menuSharp} from "ionicons/icons";
import { loadingController, menuController } from "@ionic/vue";
import ScoringLadder from '../../components/ScoringLadder';
import TableList from '../../components/TableList';
import TableGridMobile from '../../components/TableGridMobile';
import Skeleton from '../../components/Skeleton';
import {weatherCodes} from '@/utils/constants';
import { mapGetters } from "vuex";
import _ from 'lodash';
import moment from 'moment';
  
export default {
  props: [
    'entityType',
    'entityId',
  ],
  components: {
    ScoringLadder,
    Skeleton,
    TableList,
    TableGridMobile
  },
  setup() {
    return {
      flagOutline,
      podiumOutline,
      arrowBackOutline,
      arrowForwardOutline,
      caretDownOutline,
      menuSharp
    }
  },
  data() {
    const { filter } = this.$store.state.matches;
    return {
      slideOpts: {
        initialSlide: 1,
        speed: 400,
        navigation: false,
        pagination: false,
        centerInsufficientSlides: true,
        // slidesPerView: 4,
        breakpoints: {
          // when window width is >= 320px
          320: {
            slidesPerView: 3,
            spaceBetween: 20
          },
          // when window width is >= 480px
          480: {
            slidesPerView: 4,
            spaceBetween: 30
          },
          // when window width is >= 640px
          640: {
            slidesPerView: 5,
            spaceBetween: 40
          }
        }
      },
      compListOpen: false,
      dateFilter: false,
      upperCase: _.upperCase,
      get: _.get,
      find: _.find,
      ellipsisVertical,
      personCircle,
      competitions: [],
      customLeaderboard: [],
      filterSeason: undefined,
      competitionId: undefined,
      round: filter.round,
      team: filter.team,
      isMount: false,
      ladder: {},
      eventLadder: {},
      filter,
      key: 0,
      loading: true,
      eventType: undefined,
      displayMatches: true,
      displayLadders: true,
      potmHeaders: ['Round', 'Match', 'POTM Name', 'Shirt No.', 'Player Name', 'Team'],
      potmItems: [],
      nationalId: +process.env.VUE_APP_NATIONAL_ID,
    };
  },
  async beforeMount() {
    const seasons = this.$store.getters['national/seasons'];
    const currentSeason = _.find(seasons, (season) => _.get(season, 'currentSeason', false) === true);
    if (currentSeason) {
      this.filterSeason = currentSeason._id;
    }
    try {
      await this.queryCompetitions();
      const resCustomLeaderboard = await this.$http.get(
        'assemble/api/v1/live/custom-leaderboard',
        {
          params:{
            season: this.filterSeason,
            entityType: this.entityType,
            entityId: +this.entityId
          }
        }
      );
      
      this.customLeaderboard = resCustomLeaderboard.data.data;
      // assign flag custom leaderboard to each custom leaderboard
      this.customLeaderboard.forEach((customLeaderboard) => {
        customLeaderboard.isCustom = true;
      });
      this.competitions = this.customLeaderboard.concat(this.competitions);
    } catch (error) {
      console.log(error);
    }
  },
  mounted() {
  },
  computed: {
    ...mapGetters('matches', ['currentTab']),
    scoringTypes(){
      let types = [];
      const competition = _.find(this.competitions, (c) => c._id === this.competitionId);
      const isCustom = _.get(competition, 'isCustom', false);
      if (competition) {
        const useCustomScoringEvents = _.get(competition, 'competitionSettings.useCustomScoringEvents', undefined);
        const nationalScoringEvents = _.get(competition, 'competitionSettings.nationalScoringEvents', []);
        const scoringEvents = isCustom 
          ? _.get(competition, 'scoringEvents', [])
          : _.get(competition, 'competitionSettings.scoringEvents', [])
        const filteredMatches = _.filter(this.$store.state.national.scoringEvents, (st) => _.includes(nationalScoringEvents, st.type));
        const scoringResult = useCustomScoringEvents ? _.concat(scoringEvents, filteredMatches) : scoringEvents;
        if (!useCustomScoringEvents || (!scoringResult || scoringResult.length < 1)) {
          types = scoringResult && scoringResult.length ? scoringResult :  this.$store.state.national.scoringEvents;
        }
        console.log({ scoringEvents: scoringResult})
        types = scoringResult;
      }

      console.log({ scoringEvents: this.$store.state.national.scoringEvents})
      types = this.$store.state.national.scoringEvents;
      return types.filter(type => type.name);
    },
    appTitle() {
      return process.env.VUE_APP_BANNER_TITLE;
    },
    seasons(){
      const seasons =  this.$store.getters['national/seasons'];
      return seasons
    },
    rounds(){
      return _.uniq(_.map(this.matches, 'round.displayName'));
    },
    teams() {
      return _.uniq([_.map(this.matches, 'homeTeam.name'), _.map(this.matches, 'awayTeam.name')].flat());
    },
    entity() {
      return this.$store.getters['national/getEntity'];
    },
  },
  methods: {
    async queryCompetitions() {
      console.log('Querying');
      try {
        if (this.entityType === 'state') {
          const resComp = await this.$http.get(`/assemble/api/v1/live/states/${this.$route.params.id}`, {
            params:{
              season: this.filterSeason,
            }
          });
          this.competitions = _.get(resComp, 'data.competitions', []);
        } else if (this.entityType === 'association') {
          const resComp = await this.$http.get(`/assemble/api/v1/live/associations/${this.$route.params.id}`, {
            params:{
              season: this.filterSeason,
            }
          });
          this.competitions = _.get(resComp, 'data.competitions', []);
        } else if (this.entityType === 'club') {
          const resComp = await this.$http.get(`/assemble/api/v1/live/clubs/${this.$route.params.id}`, {
            params:{
              season: this.filterSeason,
            }
          });
          this.competitions = _.get(resComp, 'data.competitions', []);
        } else {
          const resComp = await this.$http.get(
            'assemble/api/v1/live/competitions',
            {
              params:{
                season: this.filterSeason,
                entityType: this.entityType,
                entityId: +this.entityId
              }
            }
          );
          this.competitions = resComp.data.data;
        }
      } catch (error) {
        console.log(error);
      }
    },
    openMenu() {
      console.log('openMenu');
      menuController.open('side');
    },
    goMatch(id) {
      console.log('entity', this.entity);
      if(this.entity && this.entity.level && this.entity.name){
        this.$router.push(`/c/${this.entity.level}/${this.entity.name}/matches/${id}`);
        return;
      }
      this.$router.push(`/matches/${id}`);
    },
    goToAS() {
      window.open('https://assemblesports.com', "_blank");
    },
    randomizeAds() {
      const freq = 5;
      const rand =  Math.random();
      return rand  <= (freq / 100);
    },
    gameStatusColor(status) {
      switch (status) {
      case 'pre-game':
        return 'dark';
      case 'final':
        return 'success';
      case 'forfeit':
      case 'washout':
        return 'warning';
      case 'disputed':
      case 'offline':
        return 'danger';
      case 'first-half':
      case 'second-half':
        return 'light';
      default:
        return 'light';
      }
    },
    async changeCompetition(_id) {
      this.competitionId = _id;
    }
  },
  watch: {
    round(name) {
      this.$store.commit('matches/setRound', name);
    },
    team(name) {
      this.$store.commit('matches/setTeam', name)
    },
    competitionId: {
      async handler(id) {
        if(!id) return;
        if(this.scoringTypes && this.scoringTypes.length > 0) {
          this.eventType = this.scoringTypes[0].type;
        }
        this.loading = true;
        this.isMount = true;
        if(this.eventType){
          this.eventLadder = [];
          const foundComp = _.find(this.competitions, {'_id': id});
          const isCustom = _.get(foundComp, 'isCustom', false);

          const resEventLadder = isCustom
            ? await this.$httpNoAuth.get(`/assemble/api/v1/live/leaderboard/custom-leaderboard/${id}`, { params: { eventType: this.eventType } })
            : await this.$httpNoAuth.get(`/assemble/api/v1/live/leaderboard/competition/${id}`, { params: { eventType: this.eventType } })
          this.eventLadder = resEventLadder.data.data;
        }
          
  
        this.loading = false;
        this.isMount = false;
        // await fetchWeather(this.matches)
      }
    },
    filterSeason: {
      async handler(id) {
        if(!id) return;
        try {
          this.loading = true;
          await this.queryCompetitions();
          const resCustomLeaderboard = await this.$http.get("assemble/api/v1/live/custom-leaderboard");
          this.customLeaderboard = resCustomLeaderboard.data.data;
          // assign flag custom leaderboard to each custom leaderboard
          this.customLeaderboard.forEach((customLeaderboard) => {
            customLeaderboard.isCustom = true;
          });
          this.competitions = this.customLeaderboard.concat(this.competitions);
  
          this.eventLadder = [];
          if(this.scoringTypes && this.scoringTypes.length > 0) {
            this.eventType = this.scoringTypes[0].type;
          }
  
          // if (this.filterSeason != id) {
          // this.competitionId = undefined;
          if (this.competitions.length) this.competitionId = this.competitions[0]._id;
          // }
  
          if (this.competitionId) {
            this.loading = true;
            this.isMount = true;
  
            if(this.eventType){
              this.eventLadder = [];
              const resEventLadder = await this.$httpNoAuth.get(`/assemble/api/v1/live/leaderboard/competition/${this.competitionId}`, { params: { eventType: this.eventType } })
              this.eventLadder = resEventLadder.data.data;
            }
          }

          this.isMount = false;
          this.loading = false;
        } catch (error) {
          console.log(error);
        }
  
        this.loading = false;
      },
      immediate: true,
    },
    eventType: {
      async handler(eventType){
        if (this.isMount) return;
        this.loading = true;
        try {
          if(eventType){
            if (eventType == 'potm') {
              this.eventLadder = [];
              const resEventLadder = await this.$httpNoAuth.get(`/assemble/api/v1/live/leaderboard/player-of-the-match/competition/${this.competitionId}`);
              this.eventLadder = resEventLadder.data.data;
              this.key++;
              this.loading = false;
            } else {
              this.eventLadder = [];
              const resEventLadder = await this.$httpNoAuth.get(`/assemble/api/v1/live/leaderboard/competition/${this.competitionId}`, { params: { eventType: eventType } });
              this.eventLadder = resEventLadder.data.data;
              this.key++;
              this.loading = false;
            }
          }
        } catch (error) {
          console.log(error);
        }
        finally {
          this.loading = false;
        }
      }
    },
  }
};
</script>
  <style scoped lang="scss">
  
  ion-title {
    font-family: 'Cairo';
  }
  
  ion-grid {
    white-space: nowrap;
     --offset-bottom: auto!important;
    --overflow: hidden;
    overflow: auto;
    &::-webkit-scrollbar {
      display: none;
    }
  }
  
  .header-bar {
    padding: 0.5rem;
  }
  
  .round-text {
    color: #fff;
    font-family: 'Cairo';
    text-align: center;
    font-size: 14px;
    text-transform: uppercase;
    // text-decoration: underline;
    // text-decoration-color: $highlight;
  }
  
  .competition-row {
    --offset-bottom: auto!important;
    --overflow: hidden;
    overflow: auto;
    &::-webkit-scrollbar {
      display: none;
    }
    background: $background !important;
  }
  
  .date-row {
    align-items: center;
    --offset-bottom: auto!important;
    --overflow: hidden;
    overflow: auto;
    &::-webkit-scrollbar {
      display: none;
    }
    padding: 1rem 1.5rem;
    background: $background !important;
    border-bottom: 1px solid #3a3a3a;
  }
  
  .chip {
    font-size: 1rem;
    color: #a9a9a9;
    font-family: 'Cairo';
    &.active {
      background: var(--highlight-color);
      color: #000;
      // color: var(--ion-color-primary);
      font-family: 'Cairo';
    }
  
    &.selectable {
      cursor: pointer;
      color: #a9a9a9;
      background: #1E1F22;
    }
  }
  
  .dateOption {
    display: flex;
    flex-direction: column;
    align-items: center;
    // gap: 0.25rem;
    span {
      color: #a9a9a9;
      font-size: 0.8rem;
      font-family: 'Cairo';
      transition: all 0.2s ease-in-out;
    }
  
    .date {
      font-size: 1rem;
    }
  
    &.active {
      // background: white;
      // color: var(--ion-color-primary);
      span {
        // font-size: 0.9rem;
        color: white !important;
        font-family: 'Cairo';
      }
    }
  
    &.selectable {
      cursor: pointer;
      color: #fff;
      // background: #1E1F22;
    }
  }
  
  .display-round-byes {
    font-size: 10px;
    color: rgba(255,196, 37, .9);
    padding: 5px;
    position: absolute;
    top: -30px;
    left: 20px;
    background: #1e1f22;
    border-top-left-radius: 5px;
    border-top-right-radius: 5px;
  }
  
  .display-round {
    font-size: 10px;
    color: rgba(255,196, 37, .9);
    padding: 5px;
    position: absolute;
    top: -32px;
    left: 40px;
    background: #1e1f22;
    border-top-left-radius: 5px;
    border-top-right-radius: 5px;
  }
  ion-item {
    --padding-start: 15px;
    --padding-end: 15px;
  }
  .flex {
    display: flex;
  }
  .flex-column {
    flex-direction: column;
  }
  .align-center {
    align-items: center;
  }
  .justify-end {
    justify-content: flex-end;
  }
  .justify-center {
    justify-content: center;
  }
  .justify-between {
    justify-content: space-between;
  }
  .justify-around {
    justify-content: space-around;
  }
  .light-text {
    font-size: 14px;
    font-weight: 400;
    text-transform: capitalize;
  }
  .normal-text {
    font-size: 15px;
    font-weight: 600;
    text-transform: capitalize;
  }
  .bold-text {
    font-size: 16px;
    font-weight: bold;
  }
  .score-text {
    font-size: 30px;
    line-height: 30px;
    font-weight: 700;
    /* color: rgba(8, 48, 109, 0.5); */
    color: white;
  }
  
  .header {
    --background: #1a2933 !important;
    color: white;
  }
  
  .custom-segment {
    background: $background !important;
  }
  
  .custom-segment ::before {
    border-left: none;
  }
  
  .custom-segment .segment-button-checked {
    color: $primary;
    --indicator-box-shadow: none;
    border-bottom: 2px solid $primary;
  }
  
  .bye-card {
    margin-inline: 1.5rem;
    position: relative;
    border-radius: 24px;
    cursor: pointer;
    // box-shadow: inset 0 0 0 1000px rgba(117, 125, 138, .25);
    // -webkit-box-shadow: inset 0 0 0 1000px rgba(117, 125, 138, .25);
  
    font-family: 'BrownStd-Regular';
    color: white;
     box-shadow: none;
    background: #171717 !important;
    .round-text {
      margin-top: 0.5rem;
      margin-bottom: 1rem;
    }
  }
  .custom-card {
    border-radius: 24px;
    cursor: pointer;
    // box-shadow: inset 0 0 0 1000px rgba(117, 125, 138, .25);
    // -webkit-box-shadow: inset 0 0 0 1000px rgba(117, 125, 138, .25);
    font-family: 'BrownStd-Regular';
    font-size: 1.2rem;
    line-height: 137.4%;
    letter-spacing: 0.02em;
    color: white;
    // background: transparent;
     box-shadow: none;
    background: #171717 !important;
    margin-inline: 1.5rem;
  
    .venue {
      letter-spacing: -0.01rem;
    }
  }
  .custom-card .card-content-ios {
    padding: 10px;
  }
  
  .custom-card .promoted-header {
    font-family: 'BrownStd-Regular';
    text-align: center;
    font-size: .9rem;
    font-weight: 600;
    text-transform: capitalize;
    line-height: 137.4%;
    letter-spacing: 0.02em;
    color: #2d3a45;
  }
  
  .list-ios, .list-md {
    padding: 0;
    background: 0;
  }
  
  ion-item {
    --background: #232528;
    --color: white;
  }
  
  .custom-segment ion-label {
    margin-bottom: 0;
  }
  
  ion-content {
    background: $background;
    --background: $background;
    --offset-bottom: auto!important;
    --overflow: hidden;
    overflow: auto;
  }
  
  ion-content::-webkit-scrollbar-track
  {
    -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.3);
    background-color: rgba(0,0,0,0.3);
  }
  
  ion-content::-webkit-scrollbar
  {
    width: .35rem;
    background-color: rgba(0,0,0,0.3);
  }
  
  @media only screen and (max-width: 768px) {
    ion-content::-webkit-scrollbar {
      width: .15rem;
      background-color: rgba(0,0,0,0.3);
    }
  }
  
  ion-content::-webkit-scrollbar-thumb
  {
    background-color: #888;
  }
  
  
  .overlay {
    background: $background;
    // background: $primary;
    padding: 0rem;
  }
  
  ion-toolbar, ion-item {
    --border-width: 0 !important;
    --background: $background;
    --color: white;
  }
  
  ion-segment-button {
    --background-hover: white !important;
    --color-hover: $highlight !important;
    --color-checked: $highlight !important;
  }
  
  .custom-segment {
    border: none;
    /* background: white; */
    border-radius: 0px;
    border-bottom: 1px solid rgba(177, 177, 177, 0.3);
    padding-top: 1rem;
    border: none;
    background: none;
     display: flex;
    // justify-content: center;
    /* border-radius: 1rem !important; */
  }
  
  .custom-segment ::before {
    border-left: none;
  }
  
  .custom-segment .in-segment {
    color: rgba(177, 177, 177, 1);
    font-size: 1.3rem;
    // background-color: rgba($primary, .7);
  }
  
  .custom-segment .segment-button-checked {
    color: rgb(234 68 68);
    border-radius: 0;
    margin-bottom: 0;
    // background-color: rgba($primary, .7);
    color: $highlight;
    font-size: 1.3rem;
    font-weight: 500;
    --indicator-height: 0;
    --indicator-box-shadow: none;
    /* --indicator-color: rgb(234, 68, 68, 0.7);
    --indicator-transform:translate3d(0, 25px, 0) scale3d(.7,1,1); */
    border-bottom: 3px solid $highlight;
  }
  .custom-segment-ladder {
    // border: none;
    margin: 0 auto;
    margin-top: 1rem;
    display: flex;
    width:70%;
    justify-content: center;
    border-radius: 0.6rem !important;
  }
  
  .custom-segment-ladder-button{
    flex-basis: 50%;
  }
  
  
  .custom-segment-ladder ::before {
    border-left: none;
  }
  
  .custom-segment-ladder .in-segment {
    color: rgba(177, 177, 177, 1);
    background-color: rgba($primary, .2);
  }
  
  .custom-segment-ladder .segment-button-checked {
    color: rgb(234 68 68);
    // margin-bottom: 0;
    background-color: rgba($primary, .7);
    color: $highlight;
    font-weight: 400;
    // --indicator-height: 0;
    // --indicator-box-shadow: none;
    //  --indicator-color: rgb(234, 68, 68, 0.7);
    // --indicator-transform:translate3d(0, 25px, 0) scale3d(.7,1,1);
    // border-bottom: 3px solid $highlight;
  }
  
  .empty-container {
    height: 60vh;
    display: flex;
    justify-content: center;
    align-items: center;
    box-shadow: none;
    -webkit-box-shadow: none;
  }
  
  .empty-container ion-card {
    padding: 4rem;
    border-radius: 1rem;
    background: transparent;
    box-shadow: none;
    -webkit-box-shadow: none;
  }
  
  .empty-placeholder {
    align-items: flex-start;
    font-family: 'BrownStd-Regular';
    font-style: normal;
    font-weight: bold;
    font-size: 1.2rem;
    line-height: 137.4%;
    /* margin-bottom: 1rem; */
    padding-left: 0;
  
    letter-spacing: 0.02em;
  
    color: white;
  }
  
  .team-name {
    font-size: 0.8rem;
    white-space: break-spaces;
  }
  
  ion-select::part(icon) {
    margin-left: 0.5rem;
    color: white !important;
    opacity: 0.85;
  }
  
  </style>
  